import { i18n } from '@/i18n'
function getLocaleDateTimeFormat (key = 'numeric_date', locale, separators = { date: '-', time: ':', datetime: ' ' }) {
  if (!locale) {
    locale = i18n.locale || 'es'
  }
  
  const dateFormat = i18n.dateTimeFormats[locale]?.[key]
  if (!dateFormat) {
    return `Formato no encontrado para la clave ${key} en el locale ${locale}.`
  }
  const dateStr = '1970-01-02T03:04:06.888'
  const exampleDate = new Date(dateStr)
  const formatter = new Intl.DateTimeFormat(locale, dateFormat)
  const formattedDate = formatter.format(exampleDate)

  // Se incluyen solo las propiedades compatibles con el-date-picker
  const formatMap = {
    year: { '2-digit': 'yy', numeric: 'yyyy' },
    month: { '2-digit': 'MM', numeric: 'M' },
    day: { '2-digit': 'dd', numeric: 'd' },
    hour: { '2-digit': 'HH', numeric: 'H' },
    minute: { '2-digit': 'mm', numeric: 'm' },
    second: { '2-digit': 'ss', numeric: 's' },
    fractionalSecondDigits: { 1: 'S', 2: 'SS', 3: 'SSS' },
  }

  if (dateFormat.hour12) {
    Object.entries(formatMap.hour).forEach(([key, value]) => { formatMap.hour[key] = value.toLowerCase() })
  }
      
  const valuesMap = {
    year: { '2-digit': '70', numeric: '1970' },
    month: { '2-digit': '01', numeric: '1' },
    day: { '2-digit': '02', numeric: '2' },
    hour: { '2-digit': '03', numeric: '3' },
    minute: { '2-digit': '04', numeric: '4' },
    second: { '2-digit': '06', numeric: '6' },
    fractionalSecondDigits: { 1: '8', 2: '88', 3: '888' },
  }



  let resultPattern = formattedDate

  for (const [unit, style] of Object.entries(dateFormat)) {
    const mappedFormat = formatMap[unit]?.[style]
    const mappedValue = valuesMap[unit]?.[style]
    resultPattern = resultPattern.replaceAll(mappedValue, mappedFormat)
  }
  if (separators.date !== null && separators.date !== undefined) {
    resultPattern = resultPattern.replace(/[\\/\\.]/g, separators.date)
  }
  if (separators.time !== null && separators.time !== undefined) {
    resultPattern = resultPattern.replace(/:/g, separators.time)
  }
  if (separators.datetime !== null && separators.datetime !== undefined) {
    resultPattern = resultPattern.replace(/, /g, separators.datetime)
  }

  return resultPattern.trim()
}

export default getLocaleDateTimeFormat
